import { AiFillCheckCircle } from 'react-icons/ai';
import DrawerButton from '../Button/DrawerButton';
import { H3 } from '../Element/Heading';

type Props = {
  dark?: boolean;
  heading: string;
  subHeading: string;
  count?: string;
};

export default function ReviewHeaderSection({
  dark,
  heading,
  subHeading,
  count,
}: Props) {
  return (
    <div className={`relative ${dark ? 'bg-blue-500' : 'bg-white'}`}>
      <div className="relative px-4 py-8 mx-auto max-w-7xl sm:py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between mx-8 md:mx-16">
          <div className="mb-8 sm:mb-0 sm:mr-8">
            <h1
              className={`text-2xl md:text-5xl text-center md:text-left font-bold capitalize ${
                dark ? 'text-white' : 'text-gray-900'
              } sm:text-3xl sm:tracking-tight lg:text-5xl`}
            >
              {heading}
            </h1>
            <h2
              className={`text-lg md:text-4xl text-center md:text-left  font-bold capitalize ${
                dark ? 'text-white' : 'text-gray-900'
              } sm:text-5xl sm:tracking-tight lg:text-4xl mt-2`}
            >
              {subHeading}
            </h2>
          </div>
          <div className="bg-white md:px-12 py-6 rounded-3xl w-full md:w-[500px] mx-auto text-center">
            <h3 className="text-2xl font-semibold mb-4">
              Maximize your solar <br />
              savings with:
            </h3>
            <div className="text-left space-y-4 px-8 ">
              <div className="flex items-center ml-2">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Personalized quotes</p>
              </div>
              <div className="flex items-center ml-2">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Pre-vetted installers</p>
              </div>
              <div className="flex items-center ml-2">
                <AiFillCheckCircle className="text-primary text-xl" />
                <p className="ml-3 font-medium">Better product & prices</p>
              </div>
            </div>
            <div className="pt-4 sm:pt-8 px-9 md:px-12">
              <DrawerButton />
            </div>
          </div>
        </div>
      </div>

      <section className="bg-gray-100 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center ">
            <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center">
              <H3 className="font-semibold text-primary text-center ">
                {count || 6}
              </H3>
              <p>EnergyPal Recommended</p>
            </div>
            <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center">
              <H3 className="font-semibold text-primary text-center ">5,822</H3>
              <p>Installer Company Profiles</p>
            </div>
            <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center">
              <H3 className="font-semibold text-primary text-center ">
                97,476+
              </H3>
              <p>Total Reviews Collected</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
